import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/heart.vue
var s = {
	name: "DtIconHeart",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["clip-path"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--heart"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Heart",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [i("g", { "clip-path": `url(#${e.uniqueID}a)` }, [...t[0] || (t[0] = [i("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M2.476 1.24a3.2 3.2 0 0 1 3.493.697l.002.002.03.03.028-.03.002-.002a3.2 3.2 0 0 1 4.533 0c1.273 1.273 1.3 3.377-.207 4.913l-.003.004-4 4a.5.5 0 0 1-.707 0L1.643 6.85C.136 5.314.163 3.21 1.436 1.937a3.2 3.2 0 0 1 1.04-.696Zm1.227.756a2.2 2.2 0 0 0-1.559.647c-.846.847-.949 2.322.211 3.505L6 9.793l3.645-3.645c1.16-1.183 1.059-2.658.212-3.504a2.204 2.204 0 0 0-2.403-.48 2.2 2.2 0 0 0-.714.478v.001l-.384.388a.5.5 0 0 1-.712 0l-.383-.388a2.2 2.2 0 0 0-1.558-.647Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 8, l), i("defs", null, [i("clipPath", { id: `${e.uniqueID}a` }, [...t[1] || (t[1] = [i("path", {
		fill: "#fff",
		d: "M0 0h12v12H0z"
	}, null, -1)])], 8, u)])], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=heart.js.map